import { Component, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { BuilderService } from '../builder-services/builder.service'
import { ProtectedImagesService } from '../protected-images.service'
import { TemplatesService } from './templates.service'
import { ViewsService } from '../views/views.service'

@Component({
  selector: 'templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {
  templatesForm: any = this.formBuilder.group({
    templateName: '',
    templateSelected: '',
    templateImage: '',
    templateCategorySelected: ''
  })
  templatesList: Array<any> = []
  templateImageSrc = ''
  templateName = ''
  templateId = ''
  templateCategorySelected = ''
  mobile = false
  templatesCategories = [
    {
      id: 'restaurants',
      name: 'Restaurants'
    },
    {
      id: 'fashion',
      name: 'Fashion'
    },
    {
      id: 'grocery',
      name: 'Grocery & Market'
    },
    {
      id: 'electronics',
      name: 'Electronics'
    },
    {
      id: 'pharmacies',
      name: 'Pharmacies'
    }
  ]
  constructor(
    private formBuilder: FormBuilder,
    private builderService: BuilderService,
    private protectedImages: ProtectedImagesService,
    private templatesService: TemplatesService,
    private viewsService: ViewsService,
  ) {
    this.getAllTemplates()
  }
  showTemplatesProgress = false
  ngOnInit(): void {
    if (window.screen.width <= 768) {
      // 768px portrait
      this.mobile = true
    }
  }

  /**
   * Get all the templates to be rendered in the Drop Down Menu
   */
  getAllTemplates = () => {
    this.showTemplatesProgress = true
    this.templatesService.getTemplates().subscribe({
      next: (templates) => {
        this.templatesList = Object.values(templates).map((element: any) => ({
          template_name: element.template_name,
          template_image: element.template_image,
          template_id: element.id,
          category: element.category,
          views: element.views
        }))
        this.showTemplatesProgress = false
      },
      error: () => {
        this.showTemplatesProgress = false
        alert('Failed to load templates, please try again')
      }
    })
  }
  onSubmit = ($event: any) => {
    const name = this.templatesForm.value.templateName || this.templateName
    const image = this.templateImageSrc
    const category = this.templatesForm.value.templateCategorySelected || this.templateCategorySelected

    if ($event.submitter.classList.contains('createTemplate')) {
      this.showTemplatesProgress = true
      const projectId = String(localStorage.getItem('selectedProject'))
      this.viewsService.getStandaloneViews(projectId).subscribe({
        next: (views) => {
          this.templatesService.insertTemplate(name, image, views, category).subscribe({
            next: () => {
              this.showTemplatesProgress = false
              this.getAllTemplates()
            },
            error: () => {
              this.showTemplatesProgress = false
              alert('Failed to create template, please try again')
            }
          })
        },
        error: () => {
          this.showTemplatesProgress = false
          alert('Failed to read project layout, please try again')
        }
      })
    } else {
      if (!this.templateId) {
        alert('Select a template to update first')
        return
      }
      const selected = this.templatesList.find((template) => template.template_id === this.templateId)
      const views = selected ? selected.views : {}
      this.showTemplatesProgress = true
      this.templatesService.updateTemplate(this.templateId, name, image, views).subscribe({
        next: () => {
          this.showTemplatesProgress = false
          this.getAllTemplates()
        },
        error: () => {
          this.showTemplatesProgress = false
          alert('Failed to update template, please try again')
        }
      })
    }
    this.protectedImages.setProtectedImages();
  }

  queryChange($event: any, type: string) {
    let data = 0
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value - 1
    } else if (type == 'slider') {
      data = $event.currentTarget.value - 1
    }
    this.templateName = this.templatesList[data].template_name
    this.templateImageSrc = this.templatesList[data].template_image
    this.templateId = this.templatesList[data].template_id
    this.templateCategorySelected = this.templatesList[data].category

    this.templatesForm.patchValue({
      templateName: this.templateName,
      templateCategorySelected: this.templateCategorySelected
    })
  }

  processFile(fileInput: any, type: string, name: string) {
    const file: File = fileInput.target.files[0]
    const reader = new FileReader()
    reader.addEventListener('load', (event: any) => {
      this.builderService.uploadImage(file, 'admin', 'templates').subscribe((imageResponse) => {
        this.templateImageSrc = imageResponse
        this.builderService.showUpdateProgress = false
      })
      // this.templateService.uploadFile(file, this.builderService.selectedProject, type, name).subscribe(
      //   (res) => {
      //     console.log(res);
      //     this.templateImageSrc = res;
      //     this.builderService.showUpdateProgress = false;
      //   },
      //   (err) => {
      //     this.builderService.showUpdateProgress = false;
      //     alert("error uploading file, please contact support");
      //   })
    })

    reader.readAsDataURL(file)
  }
}
